//Polyfills
import "./polyfills";
// Log rocket
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
//
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ConfigProvider, message } from "antd";
//Components
import App from "./app/App";
import config from "./app/config/config";
import theme from './app/config/theme';
import './app/stylesheets/index.scss';
import './app/stylesheets/index_antd.scss';

//Init Log rocket & Logs
if (!import.meta.env.VITE_OFFLINE) {
  //Log rocket
  console.log('LogRocket App ID:', config.LogRocketOptions.applicationId);
  LogRocket.init(config.LogRocketOptions.applicationId);
  setupLogRocketReact(LogRocket);
}
//Message time config
message.config({
  duration: 6,
});
//Render router with App
ReactDOM.createRoot(document.getElementById('root')).render(
  <Router>
    <ConfigProvider theme={theme}>
      <GoogleReCaptchaProvider reCaptchaKey={config.ApplicationRecaptchaKey}>
        <App />
      </GoogleReCaptchaProvider>
    </ConfigProvider>
  </Router>
);

